import Vue from 'vue';
import Vuex from 'vuex';
import { setToken, getToken, removeToken } from "../utils/token";
import { login, loginOut } from "../api/userMG";

Vue.use(Vuex);
// 登录验证
export default new Vuex.Store({
  state: {
    name: '',
    userId: '',
    collapse: false,//导航栏收缩状态
    token: getToken(),
    roleName: '',
    pd: '',
    avatar: '',
    dept_id: '',
    username: '',
    open_id: '',
    state_id:'',
    qrcode:''
  },
  getters: {
    collapse(state) {
      return state.collapse
    }
  },
  mutations: {
    SET_ROLE_NAME: (state, roleName) => {
      state.roleName = roleName
    },
    SET_USER_ID: (state, userId) => {
      state.userId = userId
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_PD: (state, pd) => {
      state.pd = pd
    },
    SET_AVATAR: (state, avatar)=>{
      state.avatar=avatar
    },
    SET_DEPTID: (state, dept_id) =>{
      state.dept_id=dept_id
    },
    SET_USERNAME: (state, username) =>{
      state.username=username
    },
    SET_COLLAPSE: (state, collapse) =>{
      state.collapse=false
    },
    SET_OPEN_ID:(state, open_id) =>{
      state.openid=open_id
    },
    SET_STATE_ID(state, state_id) {
      state.state_id=state_id
    },
    SET_QRCODE(state, qrcode) {
      state.qrcode=qrcode
    }
  },
  actions: {
    // 登录
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(response => {
          // console.log(userInfo)
          if (response.data) {
            const data = response.data
           commit('SET_ROLE_NAME', data.roles[0].slug)
            commit('SET_TOKEN', data.token)
            commit('SET_NAME', data.user.username)
            commit('SET_USER_ID', data.user.id)
            commit('SET_PD', userInfo.password)
            commit('SET_AVATAR', data.user.avatar)
            commit('SET_DEPTID', data.user.dept_id)
            commit('SET_USERNAME', data.user.name)
            commit('SET_COLLAPSE', false)
            commit('SET_OPEN_ID', data.user.openid)
            commit('SET_STATE_ID', 1)
            commit('SET_QRCODE', data.user.qrcode)
            localStorage.setItem('token', data.token)
            localStorage.setItem('userId', data.user.id)
            localStorage.setItem('roleName', data.roles[0].slug)
            localStorage.setItem('username', data.user.username)
            localStorage.setItem('pd', userInfo.password)
            localStorage.setItem('avatar', data.user.avatar)
            localStorage.setItem('dept_id', data.user.dept_id)
            localStorage.setItem('name', data.user.name)
            localStorage.setItem('collapse', false)
            localStorage.setItem('openid', data.user.openid)
            localStorage.setItem('stateid', 1)
            localStorage.setItem('qrcode', data.user.qrcode)
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        let param ={
          token:localStorage.getItem('token')
        }
        loginOut(param).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_NAME', '')
          commit('SET_ID', '')
          commit('SET_ROLE_NAME', '')
          commit('SET_PD', '')
          commit('SET_AVATAR','')
          commit('SET_DEPTID', '')
          commit('SET_USERNAME', '')
          commit('SET_OPEN_ID', "")
          commit('SET_STATE_ID', "")
          commit('SET_QRCODE', "")
          localStorage.setItem('token', '')
          localStorage.setItem('username', '')
          localStorage.setItem('userId', '')
          localStorage.setItem('roleName', '')
          localStorage.setItem('pd', '')
          localStorage.setItem('avatar', '')
          localStorage.setItem('dept_id', '')
          localStorage.setItem('name', '')
          localStorage.setItem('openid', '')
          localStorage.setItem('stateid', "")
          localStorage.setItem('qrcode', "")
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js